// HyperText.js
import React, { useState } from "react";

const CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

function getRandomChar() {
  return CHARS[Math.floor(Math.random() * CHARS.length)];
}

const HyperText = ({ text, className = "" }) => {
  const [displayText, setDisplayText] = useState(text);
  const [intervalId, setIntervalId] = useState(null);

  const handleMouseEnter = () => {
    let iteration = 0;
    clearInterval(intervalId); // Clear any previous intervals

    const newIntervalId = setInterval(() => {
      setDisplayText((prev) => {
        return text
          .split("")
          .map((char, index) => {
            if (index < iteration) {
              return text[index];
            }
            return getRandomChar();
          })
          .join("");
      });

      iteration += 1 / 3;

      if (iteration >= text.length) {
        clearInterval(newIntervalId);
        setIntervalId(null);
      }
    }, 30);

    setIntervalId(newIntervalId);
  };

  return (
    <span
      onMouseEnter={handleMouseEnter}
      className={`cursor-pointer transition-all duration-300 ${className}`}
    >
      {displayText}
    </span>
  );
};

export default HyperText;
